import undraw_bug_fixing_oc7a from './undraw_bug_fixing_oc7a.png'
import undraw_code_inspection_bdl7 from './undraw_code_inspection_bdl7.png'
import undraw_Code_thinking_re_gka2 from './undraw_Code_thinking_re_gka2.png'
import undraw_Coding_re_iv62 from './undraw_Coding_re_iv62.png'
import undraw_dev_productivity_umsq from './undraw_dev_productivity_umsq.png'
import undraw_Developer_activity_re_39tg from './undraw_Developer_activity_re_39tg.png'
import undraw_Download_re_li50 from './undraw_Download_re_li50.png'
import undraw_feeling_proud_qne1 from './undraw_feeling_proud_qne1.png'
import undraw_Freelancer_re_irh4 from './undraw_Freelancer_re_irh4.png'
import undraw_hacker_mind_6y85 from './undraw_hacker_mind_6y85.png'
import undraw_Hacker_mindset_re_8a33 from './undraw_Hacker_mindset_re_8a33.png'
import undraw_laravel_and_vue_59tp from './undraw_laravel_and_vue_59tp.png'
import undraw_Mind_map_re_nlb6 from './undraw_Mind_map_re_nlb6.png'
import undraw_Mobile_application_mr4r from './undraw_Mobile_application_mr4r.png'
import undraw_my_app_re_gxtj from './undraw_my_app_re_gxtj.png'
import undraw_portfolio_website_lidw from './undraw_portfolio_website_lidw.png'
import undraw_Programming_re_kg9v from './undraw_Programming_re_kg9v.png'
import undraw_server_cluster_jwwq from './undraw_server_cluster_jwwq.png'
import undraw_Server_push_re_303w from './undraw_Server_push_re_303w.png'
import undraw_Source_code_re_wd9m from './undraw_Source_code_re_wd9m.png'
import undraw_Startup_life_re_8ow9 from './undraw_Startup_life_re_8ow9.png'
import undraw_static_website_0107 from './undraw_static_website_0107.png'
import undraw_version_control_re_mg66 from './undraw_version_control_re_mg66.png'

export const images = [
  undraw_bug_fixing_oc7a,
  undraw_code_inspection_bdl7,
  undraw_Code_thinking_re_gka2,
  undraw_Coding_re_iv62,
  undraw_dev_productivity_umsq,
  undraw_Developer_activity_re_39tg,
  undraw_Download_re_li50,
  undraw_feeling_proud_qne1,
  undraw_Freelancer_re_irh4,
  undraw_hacker_mind_6y85,
  undraw_Hacker_mindset_re_8a33,
  undraw_laravel_and_vue_59tp,
  undraw_Mind_map_re_nlb6,
  undraw_Mobile_application_mr4r,
  undraw_my_app_re_gxtj,
  undraw_portfolio_website_lidw,
  undraw_Programming_re_kg9v,
  undraw_server_cluster_jwwq,
  undraw_Server_push_re_303w,
  undraw_Source_code_re_wd9m,
  undraw_Startup_life_re_8ow9,
  undraw_static_website_0107,
  undraw_version_control_re_mg66
]
